import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  item: {
    flex: 1,
    padding: 1,
  },
  content: {
    flex: 1,
    position: 'relative',
  },
  stretch: {
    position: 'absolute',
    height: '100%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
  },
  gridContainer: {
    width: '100%',
    height: '100%',
    flex: 1,
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  scrollContainer: {
    flex: 1,
  },
});
